import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';

export type SendEmail = {
  to_email: string;
  type: string;
  is_template: string;
};

export type SendSMS = {
  to_email: string;
  type: string;
  is_template: string;
};

export type SendPushMessage = {
  title: string;
  body: string;
};

const $http = new APIManager();

const Api = {
  /**
   * [POST] Send Email
   * --
   */
  sendEmail: async (body: SendEmail) => {
    try {
      const res = await $http.post(APIConstant.SEND_EMAIL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Send SMS
   * --
   */
  sendSMS: async (body: SendSMS) => {
    try {
      const res = await $http.post(APIConstant.SEND_SMS, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Send Push Message
   * --
   */
  sendPushMessage: async (body: SendPushMessage) => {
    try {
      const res = await $http.post(APIConstant.SEND_PUSH_MESSAGE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
